import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

export const usePermission = () => {
  const { currentUser } = useSelector((state: RootState) => state.auth);

  const hasPermission = (code: string): boolean => {
    if (!currentUser?.role) return false;
    if (currentUser.role.role_code === 'SUPERADMIN') return true;
    if (!currentUser.role.permissions?.length) return false;
    return currentUser.role.permissions.some((p) => p.code === code);
  };

  return { hasPermission };
};
